const deeplinkOptions = {
    home: 'home',
    franquicia: 'franchise',
    producto: 'product',
    promocion: 'promo',
    coupon: 'coupon',
};

export default deeplinkOptions;
